/* import __COLOCATED_TEMPLATE__ from './tabs.hbs'; */
import Component from '@glimmer/component';

export default class PlaylistTabsComponent extends Component {
  menuItems = [
    {
      name: 'Playlist',
      link: 'authenticated.playlists.show.index',
    },
    {
      name: 'Teams',
      link: 'authenticated.playlists.show.teams',
    },
  ];
}
